import { addReducer } from "incremental-redux-reducers";

const initialState = {
  patients: [],
  meta: {}
};

export default addReducer(
  "locationPatientLowRisk",
  function locationPatientLowRiskReducer(state = initialState, action) {
    switch (action.type) {
      case "LOCATION_LOWRISK_PATIENT_LOAD":
        return {
          ...state,
          patients: action.patients,
          meta: action.meta
        };
      case "LOCATION_LOWRISK_PATIENT_LOAD_MORE":
        return {
          patients: [...state.patients, ...action.patients],
          meta: action.meta
        };
      default:
        return state;
    }
  }
);
